import { Group } from '@ms/yammer-data/dist/state/types';
import { useGroupThrows } from '@ms/yammer-hooks/dist/groups';
import { useLegacyUrl } from '@ms/yammer-hooks/dist/urls';
import { convertGroupDatabaseIdToUrlId } from '@ms/yammer-web-support/dist/urls';
import { FC } from 'react';

import { OutboundLegacyRedirectProps } from './OutboundLegacyRedirect';

export interface OutboundLegacyRedirectWithGroupIdFulfilledProps extends OutboundLegacyRedirectProps {
  readonly groupId: Group['id'];
}

const OutboundLegacyRedirectWithGroupIdFulfilled: FC<OutboundLegacyRedirectWithGroupIdFulfilledProps> = ({
  target,
  groupId,
}) => {
  const { databaseId: groupDatabaseId } = useGroupThrows(groupId);
  const groupDatabaseUrlId = convertGroupDatabaseIdToUrlId(groupDatabaseId);
  const targetWithGroupId = target.replace(/:groupId/, groupDatabaseUrlId);

  const path = useLegacyUrl(`/${targetWithGroupId}`);
  window.location.replace(path);

  return null;
};

export default OutboundLegacyRedirectWithGroupIdFulfilled;
